<template>
  <div class="paragraph-base" :class="[this.color ? 'secondary' : 'primary']">
    <div>
      <h2 v-if="this.title" class="paragraph-title">{{ this.title }}</h2>
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    title: String,
    color: {
      type: String,
    },
  },
});
</script>
<style lang="scss" scoped>
.paragraph-base {
  border-radius: 0.8rem;
  margin-top: $spacing-xsmall;
  padding: $spacing-xsmall;
  box-sizing: border-box;
  @media (min-width: $constraint-width-small) {
    margin-top: $spacing-small;
    padding: $spacing-small;
  }
}
.primary {
  background-color: rgba($color-primary, 0.5);
}
.secondary {
  background-color: $color-gray;
}
.paragraph-title {
  margin: 0 0 $spacing-small 0;
}
</style>
